export const CAMPANIA_ASO = [
  {
    idTipoAsociacion: 1,
    tipoAsociacion: 'PARTIDO POLÍTICO'
  },
  {
    idTipoAsociacion: 3,
    tipoAsociacion: 'COALICIÓN'
  },
  {
    idTipoAsociacion: 4,
    tipoAsociacion: 'CANDIDATURA INDEPENDIENTE'
  },
  {
    idTipoAsociacion: 5,
    tipoAsociacion: 'CANDIDATURA COMÚN'
  }
];
export const PRECAMPANIA_ASO = [
  {
    idTipoAsociacion: 1,
    tipoAsociacion: 'PRECANDIDATO'
  }
  // {
  //   idTipoAsociacion: 3,
  //   tipoAsociacion: 'COALICIÓN'
  // },
  // {
  //   idTipoAsociacion: 5,
  //   tipoAsociacion: 'CANDIDATURA COMÚN'
  // }
];

export const APOYO_CIUDADANO_ASO = [
  {
    idTipoAsociacion: 4,
    tipoAsociacion: 'ASPIRANTE'
  }
];

export const INTERCAMPANIA_ASO = [
  {
    idTipoAsociacion: 1,
    tipoAsociacion: 'PRECANDIDATO / PARTIDO POLÍTICO'
  },
  {
    idTipoAsociacion: 3,
    tipoAsociacion: 'COALICIÓN'
  },
  {
    idTipoAsociacion: 4,
    tipoAsociacion: 'ASPIRANTE / CANDIDATO INDEPENDIENTE'
  },
  {
    idTipoAsociacion: 5,
    tipoAsociacion: 'CANDIDATURA COMÚN'
  }
];
